<template>
	<div class="edit">
		<Breadcrumb />
		<div class="edit-content">
			<div class="step-box" v-show="activeTab!='linkAdd'">
				<step-add moduleType="eduResearch" @changTab="changTab" @submit="allSubmit" :activeTab="activeTab" :isChangeTab="isChangeTab"></step-add>
			</div>
			<div class="form-box" v-if="activeTab=='eduForm'">
				<!-- 创建活动 -->
				<edu-form @changTab="changTab" @changIsChangeTab="changIsChangeTab" @submit="allSubmit"></edu-form>
			</div>
			<div class="link-list" v-if="activeTab=='link'">
				<!-- 活动环节 -->
				<link-info moduleType="eduResearch" @changTab="changTab"></link-info>
			</div>
			<div class="link-edit" v-if="activeTab=='linkAdd'">
				<!-- 新增环节 -->
				<link-form moduleType="eduResearch" @changTab="changTab" :linkInfo="linkInfo"></link-form>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import StepAdd from "@/components/common/StepAdd.vue";
import EduForm from "@/components/eduResearch/EduForm.vue";
import LinkInfo from "@/components/common/LinkInfo.vue";
import LinkForm from "@/components/common/LinkForm.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState, mapGetters } from "vuex";
export default {
	computed: {
		...mapState(["userInfo"])
	},
	components: {
		Breadcrumb,
		StepAdd,
		EduForm,
		LinkInfo,
		LinkForm
	},
	data() {
		return {
			activeTab: "eduForm", // eduForm活动新增  link环节   linkAdd 环节新增
			isChangeTab: false, //是否可以切换 tab
			//环节类型
			linkInfo: {
				nodeType: "",
				nodeDesc: ""
			}
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			sessionStorage.getItem("actCode") && (this.isChangeTab = true)
		},
		changTab(code, linkInfo) {
			this.linkInfo = linkInfo;
			this.activeTab = code;
		},
		//下一步
		changIsChangeTab(code) {
			this.isChangeTab = code;
		},
		async allSubmit() {
			if (sessionStorage.getItem("actCode")) {
				let linkList = await getData("/research/getActiveNodeTopicList", {
					actCode: sessionStorage.getItem("actCode"),
					isSub: 0 //是否是子活动节点，0：否，1：是     只有项目课题研究是1
				});
				// if(linkList.length===0){
				// 	this.$message.error("请先完善活动环节信息！");
				// 	return
				// }

				await postData("/research/updateActiveStatus", {
					actCode: sessionStorage.getItem("actCode"),
					operatorId: this.userInfo.userId
				});
				this.$message.success("发布成功！");
				this.$router.push({ name: "eduResearch" });
			} else {
				this.$message.error("请先完善活动信息 !");
			}
		}
	},
	watch: {}
};
</script>

<style lang="less" scoped>
.edit {
	.edit-content {
		.step-box {
			margin-top: 15px;
		}
		.form-box {
			margin-top: 15px;
			background-color: #fff;
		}
		.link-list {
			margin-top: 15px;
			background-color: #fff;
		}
		.link-edit {
			margin-top: 15px;
			background-color: #fff;
		}
	}
}
</style>
